import React, { PureComponent as Component } from "react";
import KickImage from 'Reuseables/KickImage';
import propTypes from "prop-types";
import { Button, Row, Col, Collapse } from "reactstrap";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import SizeInfo from "./SizeInfo";
import { timingSafeEqual } from "crypto";
import _ from "lodash";
import {
  accessoriesCondition,
  dustBag,
  boxHandbag,
  handbagCondition,
  sneakersCondition
} from "../../../utils/Helpers";

class SneakerCondition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _collapseShippingReturn: false,
      preVerifiedSizesCheck: false
    };
    this.shippingReturnToggle = this.shippingReturnToggle.bind(this);
    this.defectCondition = this.defectCondition.bind(this);
    this.detailCondition = this.detailCondition.bind(this);
  }

  shippingReturnToggle() {
    this.setState({
      _collapseShippingReturn: !this.state._collapseShippingReturn
    });
  }

  defectCondition(boolean, defects) {
    switch (boolean) {
      case true:
        return this.detailCondition(defects);
      case false:
        return (
          <p>
            Accessories - <span className="condition">Perfect Condition</span>
          </p>
        );

      default:
        return (
          <p>
            Accessories - <span className="condition">Perfect Condition</span>
          </p>
        );
    }
  }

  detailCondition(defects) {
    const condition = defects
      .filter(item => item.value)
      .map(item => item.display_name)
      .join(", ");

    return (
      <p>
        Accessories - <span className="condition">{condition}</span>
      </p>
    );
  }

  handbagDefect(data) {
    return this.detailHandbag(data);
  }

  detailHandbag(data) {
    const str = data
      .filter(item => item.value)
      .map(item => item.display_name)
      .join(", ");

    return str;
  }

  render() {
    const uniqueDefects = _.uniqBy(this.props.defects, "name");

    const dustBagDefects = uniqueDefects
      ? uniqueDefects.find(a => a.name === "DUST_BAG") || {}
      : {};
    const boxHandbagDefects = uniqueDefects
      ? uniqueDefects.find(a => a.name === "BOX") || {}
      : {};
    const luxuryDetailArr = [
      accessoriesCondition(this.props.missing_accessories),
      dustBag(dustBagDefects.value),
      boxHandbag(boxHandbagDefects && boxHandbagDefects.value),
      this.props.sneakers_defect ? this.handbagDefect(uniqueDefects) : ""
    ];
    const luxuryDetail = luxuryDetailArr
      .filter(item => item !== "" && item !== "Missing Box")
      .map(item => item)
      .join(", ");
    
    //CHECK OTHER BRAND NEW SAME SIZES
    const otherSizes = this.props.sell && this.props.dataAvailableSize && this.props.dataAvailableSize.length > 0 && this.props.dataAvailableSize.filter((item) => item.size_id === this.props.sell.size_id);

    return (
      <div className="condition_wrapper">
        {
          this.props.isVintage? null
          :
          this.props.category === "handbags" ? (
            <p>
              Accessories - <span className="condition">{luxuryDetail}</span>
            </p>
          ) : (
            <div>
              {!this.props.hide_box_info && (
                <p>
                  Box -{" "}
                  <span className="condition">
                    {this.props.box_condition === "SEMPURNA"
                      ? "Perfect Condition"
                      : this.props.box_condition === "CACAT"
                      ? "Defect"
                      : "Missing Box"}
                  </span>
                </p>
              )}
              {this.props.category === "sneakers" ? (
                <p>
                  Accessories -{" "}
                  <span className="condition">
                    {!this.props.missing_accessories
                      ? "Complete"
                      : "Missing Accessories"}
                    {this.props.yellowing ? ", Yellowing" : null}
                    {this.props.sneakers_defect ? ", Defect" : null}
                    {this.props.display_item ? ", Display Item" : null}
                  </span>
                </p>
              ) : (
                this.defectCondition(
                  this.props.sneakers_defect,
                  this.props.defects
                )
              )}
            </div>
          )
        }
        <Row className="row-wrapper">
          <Col className="first-col col-sm-auto">
            <ButtonWrapper>
              <Button className="btn btn-grey no-outline" color="secondary">
                {this.props.isVintage? "Vintage" : sneakersCondition(this.props.sneaker_condition)}
              </Button>
            </ButtonWrapper>
            {otherSizes && otherSizes.length > 1 && !this.props.offerPage && <SizeInfo {...this.props} />}
          </Col>
          <Col className="second-col text-center col-sm-auto">
            {(!otherSizes || otherSizes.length <= 1) && (
                  this.props.category === "lifestyles" ? null : (
                    <div className="price">
                    {
                      this.props.category === "handbags" && this.props.sneaker_size.US == "All Size"? null
                      :
                      <>
                        {
                          this.props.category === "sneakers" ? (
                            <span>{this.props.isVilla ? "CM" : "US"}</span>
                          ) : (
                            <span>Size</span>
                          )
                        }
                        <h4 className="size-us">
                          {this.props.isVilla && this.props.category === "sneakers"
                            ? this.props.sneaker_size.cm
                            : this.props.sneaker_size.US}
                        </h4>
                      </>
                    }
                    </div>
                  )
              )
            }
          </Col>
        </Row>
      </div>
    );
  }
}
SneakerCondition.propTypes = {
  pre_order: propTypes.number,
  sneaker_condition: propTypes.string,
  sneaker_size: propTypes.string
};

SneakerCondition.defaultProps = {
  sneaker_condition: "BARU",
  box_condition: "SEMPURNA",
  yellowing: false,
  missing_accessories: false,
  sneakers_defect: false,
  display_item: false,
  pre_verified: false,
  pre_order: false
};

const WrapperDescription = styled.div`
  width: 100%;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  padding: 15px 0;
  margin: 15px 0px 15px 0px;
`;

const ButtonWrapper = styled.div`
  display: inline-block;
  margin-right: 10px;
  margin-top: 10px;
  width: 120px;
`;

const Title = styled.p`
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 1em !important;
`;

const Description = styled.div`
  margin-bottom: 1em;
`;

const SmallNotes = styled.p`
  font-style: italic;
  font-size: 11px;
  color: #bbb;
  direction: rtl;
  text-align: justify;
`;

export default withRouter(SneakerCondition);